module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-t120"
  }, [_c('exampaper', {
    attrs: {
      "page": _vm.page,
      "selectFlag": _vm.selectFlag,
      "thirdParty": _vm.thirdParty,
      "exampaperData": _vm.exampaperData,
      "serviceId": _vm.serviceId,
      "packageId": _vm.packageId,
      "cId": _vm.cId,
      "moduleId": _vm.moduleId,
      "versionId": _vm.versionId
    },
    on: {
      "submitExampaper": _vm.submitExampaper
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84ad3d50","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/selectListenSpeak.vue
// module id = 1230
// module chunks = 1